export const CONTACT = {
  whatsappDigits: '573002362190',
  phoneDisplay: '+57 300 236 2190',
  email: 'nutripetgourmetadmin@gmail.com',
};

export const formatCOP = (price) => {
  return `$${Math.round(price).toLocaleString('es-CO').replace(/,/g, '.')}`;
};

export const convertLbToKg = (lb) => {
  return (lb * 0.453592).toFixed(2).replace('.', ',');
};

export const convertOzToG = (oz) => {
  return Math.round(oz * 28.3495);
};

export const formatWeight = (weightOriginal) => {
  return weightOriginal || '';
};

export const slugify = (text) => {
  return text
    .toLowerCase()
    .replace(/[^a-z0-9\s-]/g, '')
    .replace(/[\s-]+/g, '-')
    .replace(/^-+|-+$/g, '');
};

export const getMinPrice = (variants) => {
  if (!variants || variants.length === 0) return 0;
  return Math.min(...variants.map(v => v.price_retail_with_tax));
};

export const getMaxPrice = (variants) => {
  if (!variants || variants.length === 0) return 0;
  return Math.max(...variants.map(v => v.price_retail_with_tax));
};

export const buildWhatsAppUrl = (message) => {
  const phone = CONTACT.whatsappDigits;
  return `https://wa.me/${phone}?text=${encodeURIComponent(message)}`;
};
